import { RMConst } from "./RMConst";
import { MapConfiguration } from "../types";

export const mapStyles = [];

export const MapConfigurationDefault: MapConfiguration = {
  mapFramework: RMConst.Map.MapFramework.LEAFLET,
  tileSource: null,
  tileSourceUrl: null,
  legend: { display: true, position: RMConst.Position.RIGHT_TOP },
  zoomControl: { display: true, position: RMConst.Position.RIGHT_TOP },
  scaleControl: { display: true, position: RMConst.Position.RIGHT_BOTTOM },
  zoom: 2,
  showTraffic: false,
  showBicycling: false,
  showWeather: false,
  showHeat: false,
  minZoom: 2,
  maxZoom: 12,
  mapTypeControl: false,
  scrollwheel: true,
  streetViewControl: false,
  panControl: false,
  center: { lat: 51.575363, lng: -0.065918 },
  startupSpan: 360,
  styles: mapStyles,
};

export const PopUpMapConfigurationDefault = {
  mapFramework: RMConst.Map.MapFramework.LEAFLET,
  tileSourceUrl: null,
  legend: { display: false, position: null },
  zoomControl: { display: true, position: RMConst.Position.RIGHT_TOP },
  scaleControl: { display: false, position: RMConst.Position.RIGHT_BOTTOM },
  zoom: 20,
  showTraffic: false,
  showBicycling: false,
  showWeather: false,
  showHeat: false,
  mapTypeControl: false,
  scrollwheel: true,
  streetViewControl: false,
  panControl: false,
  center: { lat: 51.4706, lng: -0.461941 },
};
